import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaIconButtonComponent} from './la-icon-button.component';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [LaIconButtonComponent],
  declarations: [LaIconButtonComponent],
  providers: []
})
export class LaIconButtonModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaIconButtonModule,
      providers: []
    };
  }
}
